import Vue from 'vue';
import Router from 'vue-router';


Vue.use(Router);
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Hello",
      component: () =>
        import(/* webpackChunkName: "home-page" */ "./pages/Index")
    },
    {
      path: "/witaj-na-naszej-stronie",
      name: "Witaj na naszej stronie",
      component: () =>
        import(/* webpackChunkName: "our-page" */ "./pages/Oursite")
    },
    {
      path: "/dlaczego-veki",
      name: "Dlaczego veki",
      component: () => import(/* webpackChunkName: "why-us" */ "./pages/Whyus")
    },
    {
      path: "/galeria",
      name: "Galeria",
      component: () =>
        import(/* webpackChunkName: "gallery" */ "./pages/Gallery")
    },
    {
      path: "/kontakt",
      name: "Kontakt",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./pages/Contact")
    },
    {
      path: "/przelicznik",
      name: "Przelicznik",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./pages/Calculator")
    },
    {
      path: "/jak-mierzyc-szuflade",
      name: "Jak mierzyc szuflade",
      component: () =>
        import(/* webpackChunkName: "contact" */ "./pages/HowToMeasure")
    },
    {
      path: "/moje-konto",
      name: "Moje konto",
      component: () =>
        import(/* webpackChunkName: "my-account" */ "./pages/account/Index")
    },
    {
      path: "/moje-konto/lost-password",
      name: "Zapomniane hasło",
      component: () =>
        import(/* webpackChunkName: "lost-password" */ "./pages/account/LostPassword")
    },
    {
      path: "/moje-konto/edit-account/",
      name: "Edycja konta",
      component: () =>
        import(/* webpackChunkName: "my-account-edit" */ "./pages/account/Edit")
    },
    {
      path: "/moje-konto/orders/",
      name: "Moje zamówienia",
      component: () =>
        import(/* webpackChunkName: "my-account-orders" */ "./pages/account/orders/Index")
    },
    {
      path: "/moje-konto/order/:id",
      name: "Moje zamówienie",
      component: () =>
        import(/* webpackChunkName: "my-account-orders-one" */ "./pages/account/orders/one/Index")
    },
    {
      path: "/moje-konto/downloads",
      name: "Moje pliki do pobrania",
      component: () =>
        import(/* webpackChunkName: "my-account-downloads" */ "./pages/account/Downloads")
    },
    {
      path: "/moje-konto/edit-address",
      name: "Moje adresy",
      component: () =>
        import(/* webpackChunkName: "my-account-addresses" */ "./pages/account/addresses/Index")
    },
    {
      path: "/moje-konto/edit-address/rozliczeniowy",
      name: "Moje adresy rozliczeniowe",
      component: () =>
        import(/* webpackChunkName: "my-account-addressses-billing" */ "./pages/account/addresses/one/Billing")
    },
    {
      path: "/moje-konto/edit-address/przesylki",
      name: "Moje adresy wysyłkowe",
      component: () =>
        import(/* webpackChunkName: "my-account-addressses-shipping" */ "./pages/account/addresses/one/Shipping")
    },
    {
      path: "/regulamin",
      name: "Regulamin",
      component: () =>
        import(/* webpackChunkName: "rules" */ "./pages/important/Rules")
    },
    {
      path: "/polityka-prywatnosci",
      name: "Polityka prywatności",
      component: () =>
        import(/* webpackChunkName: "privacy-policy" */ "./pages/important/Privacy-policy")
    },
    {
      path: "/inspiracje",
      name: "Inspiracje",
      component: () =>
        import(/* webpackChunkName: "blog" */ "./pages/blog/Index")
    },
    {
      path: "/inspiracje/:name/",
      name: "Inspiracje post",
      component: () =>
        import(/* webpackChunkName: "blog-post" */ "./pages/blog/One")
    },
    {
      path: "/sklep",
      name: "Sklep",
      component: () =>
        import(/* webpackChunkName: "shop" */ "./pages/shop/Index")
    },
    {
      path: "/koszyk",
      name: "Koszyk",
      component: () =>
        import(/* webpackChunkName: "shop-cart" */ "./pages/shop/Cart")
    },
    {
      path: "/zamowienie",
      name: "Zamowienie",
      component: () =>
        import(/* webpackChunkName: "shop-checkout" */ "./pages/shop/Checkout")
    },
    {
      path: "/checkout/order-received/:orderId",
      name: "Zamowienie otrzymane",
      component: () =>
        import(/* webpackChunkName: "shop-checkout" */ "./pages/shop/Order/Index")
    },
    {
      path: "/checkout/order-pay/:orderId/",
      name: "Zapłata za zamówienie",
      component: () =>
        import(/* webpackChunkName: "shop-checkout" */ "./pages/shop/Order/Pay")
    },
    {
      path: "/product/:name/",
      name: "Strona produktu",
      component: () =>
        import(/* webpackChunkName: "shop-products" */ "./pages/shop/Product/Index")
    },
    {
      path: "/product-category/:name/",
      name: "Kategoria produktu",
      component: () =>
        import(/* webpackChunkName: "shop-category" */ "./pages/shop/Category/Index")
    },
    {
      path: "/product-tag/:name/",
      name: "Tag produktu",
      component: () =>
        import(/* webpackChunkName: "shop-tag" */ "./pages/shop/Tag/Index")
    },
    {
      path: "/pojemniki",
      name: "Pojemniki",
      component: () =>
        import(/* webpackChunkName: "shop-containers" */ "./pages/shop/Category/Containers")
    },
    {
      path: "/pudelka",
      name: "Pudelka",
      component: () =>
        import(/* webpackChunkName: "shop-boxes" */ "./pages/shop/Category/Boxes")
    },
    {
      path: "/rynienki",
      name: "Rynienki",
      component: () =>
        import(/* webpackChunkName: "shop-larvals" */ "./pages/shop/Category/Larvals")
    },
    {
      path: "/organizery",
      name: "Organizery",
      component: () =>
        import(/* webpackChunkName: "shop-organisers" */ "./pages/shop/Category/Organisers")
    },
    {
      path: "/konfigurator-modularny/",
      name: "Konfigurator-modularny",
      component: () =>
        import(/* webpackChunkName: "konfigurator-modularny" */ "./pages/generator/modular/Index")
    },
    {
      path: "/konfigurator",
      name: "Konfigurator",
      component: () =>
        import(/* webpackChunkName: "konfigurator" */ "./pages/generator/Index")
    },
    {
      path: "/konfigurator/:id",
      name: "Konfigurator-zapisany",
      component: () =>
        import(/* webpackChunkName: "konfigurator" */ "./pages/generator/Index")
    },
    {
      path: "/szuflada",
      name: "Szuflada",
      component: () =>
        import(/* webpackChunkName: "konfigurator-zapytania" */ "./pages/generator/askings/Index")
    },
    {
      path: "**",
      name: "404",
      component: () => import(/* webpackChunkName: "404-page" */ "./pages/404")
    }
  ]
});